import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { trigger,state,style,animate,transition } from '@angular/animations';
//import { BROWSER_ANIMATIONS_PROVIDERS } from '@angular/platform-browser/animations/src/providers';
import { HttpClientModule } from '@angular/common/http';

import { MDBBootstrapModulesPro, MDBSpinningPreloader, ToastModule } from 'ng-uikit-pro-standard';

import { HotkeyModule } from 'angular2-hotkeys';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HomePageComponent } from './shell/home-page/home-page.component';
import { StandbyDashboardComponent } from './dispatch/standby-dashboard/standby-dashboard.component';
import { DayDetailsComponent } from './dispatch/standby-dashboard/day-details/day-details.component';
import { DayItemDetailsComponent } from './dispatch/standby-dashboard/day-item-details/day-item-details.component';
import { ReadonlyComponent } from './reservations/readonly/readonly.component';
import { ReservationsComponent } from './reservations/reservations.component';
import { CallBoardDashboardComponent } from './contact-center/call-board-dashboard/call-board-dashboard.component';
import { AgentBoardDashboardComponent } from './contact-center/agent-board-dashboard/agent-board-dashboard.component';
import { AppCookieService } from './app-cookie.service';
import { AuthComponent } from './share/components/auth/auth.component';
import { AlertAnalyzesComponent } from './contact-center/avaya-dashboards/alert-analyzes/alert-analyzes.component';
import { AlertDetailComponent } from './contact-center/avaya-dashboards/alert-analyzes/alert-detail/alert-detail.component';
import { EosListModule } from './dispatch/eos-list/eos-list.module';
import { FeedbackEntryComponent } from './share/feedback/feedback-entry/feedback-entry.component';
import { ReportsDashboardComponent } from './reports/reports-dashboard/reports-dashboard.component';
import { TableDataComponent } from './reports/table-data/table-data.component';
import { StatsCardComponent } from './shell/common/stats-card/stats-card.component';
import { ExpWinAccountabilityComponent } from './reservations/exp-win-accountability/exp-win-accountability.component';
import { ExpWinAccountabilityDetailComponent } from './reservations/exp-win-accountability/exp-win-accountability-detail/exp-win-accountability-detail.component';
import { NegToPosPipe } from './share/pipes/neg-to-pos.pipe';
import { AuthGuard } from './share/guards/auth.guard';
import { AgmCoreModule } from '@agm/core';

import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from './share/services/auth.interceptor';
import { NetjetsCrossroadsComponent } from './reservations/netjets-crossroads/netjets-crossroads.component';
import { PageLoaderComponent } from './share/pages/page-loader/page-loader.component';
import { CardHeaderComponent } from './share/components/card-header/card-header.component';
import { PageHeaderComponent } from './share/pages/page-header/page-header.component';
import { RateIssueComponent } from './reservations/rates/rate-issue/rate-issue.component';
import { PageDataTableComponent } from './share/pages/page-data-table/page-data-table.component';
import { DataTableCardComponent } from './share/components/data-table-card/data-table-card.component';
import { LiveGpsComponent } from './dispatch/live-gps/live-gps.component';
import { AffPortExceptionComponent } from './affiliates/affiliate-portal/aff-port-exception/aff-port-exception.component';
import { AppBuddyComponent } from './app-buddy/app-buddy.component';
import { TourManagementComponent } from './reservations/tour-management/tour-management.component';
import { ViewPayReportComponent } from './affiliates/affiliate-portal/components/view-pay-report/view-pay-report.component';
import { WebApplicationsComponent } from './reservations/web-applications/web-applications.component';
import { AffRateIssueComponent } from './affiliates/aff-rate-issue/aff-rate-issue.component';
import { DataTablePaginationComponent } from './share/components/data-table-pagination/data-table-pagination.component';
import { ExcelDocsComponent } from './share/excel-docs/excel-docs.component';
import { RatesDashboardComponent } from './reservations/rates/rates-dashboard/rates-dashboard.component';
import { DiscountCalculatorComponent } from './reservations/rates/discount-calculator/discount-calculator.component';
import { TourManagementDetailComponent } from './reservations/tour-management/tour-management-detail/tour-management-detail.component';
import { PayrollComponent } from './chauffeurs/payroll/payroll.component';
import { VehicleRequestPageComponent } from './reservations/pages/vehicle-request-page/vehicle-request-page.component';
import { FormAutoCompleteComponent } from './share/forms/form-auto-complete/form-auto-complete.component';
import { FormInputComponent } from './share/forms/form-input/form-input.component';
import { FormOkCancelComponent } from './share/forms/form-ok-cancel/form-ok-cancel.component';
import { EclsButtonComponent } from './share/forms/form-button/form-button.component';
import { CreditCardIdentityCaptureComponent } from './reservations/components/credit-card-identity-capture/credit-card-identity-capture.component';
import { CreditCardIdentityPageComponent } from './reservations/pages/credit-card-identity-page/credit-card-identity-page.component';
import { FormCommentComponent } from './share/forms/form-comment/form-comment.component';
import { UserActivityMonitorComponent } from './reservations/user-activity-monitor/user-activity-monitor.component';
import { TrendReportsComponent } from './reports/trend-reports/trend-reports.component';
import { TrendDashboardComponent } from './reports/trend-dashboard/trend-dashboard.component';
import { CardChartComponent } from './share/components/card-chart/card-chart.component';
import { DataTableComponent } from './share/components/data-table/data-table.component';
import { FormSelectComponent } from './share/forms/form-select/form-select.component';
import { MinToTimePipe } from './share/pipes/min-to-time.pipe';
import { ToastComponent } from './share/toasts/toast/toast.component';
import { WweManifestPageComponent } from './reservations/pages/wwe-manifest-page/wwe-manifest-page.component';
import { FormProgressComponent } from './share/forms/form-progress/form-progress.component';
import { ChauffeurEmailsComponent } from './chauffeurs/chauffeur-emails/chauffeur-emails.component';
import { LiveTripsPageComponent } from './external/pages/live-trips/live-trips-page.component';
import { SalesmanReportsComponent } from './reports/salesman-reports/salesman-reports.component';
import { SalesmanDashboardComponent } from './reports/salesman-dashboard/salesman-dashboard.component';
import { FrontAnalysisPageComponent } from './reservations/pages/front-analysis-page/front-analysis-page.component';
import { VendorPayoutComponent } from './accounting/vendor-payout/vendor-payout.component';
import { MdbFileUploadModule } from 'mdb-file-upload';
import { DataTableCardSimpleComponent } from './share/components/data-table-card-simple/data-table-card-simple.component';
import { ChauffeurHrComponent } from './chauffeurs/chauffeur-hr/chauffeur-hr.component';
import { AffiliatePayoutComponent } from './costing/affiliate-payout/affiliate-payout.component';
import { EclsPowerBiReportComponent } from './share/components/ecls-power-bi-report/ecls-power-bi-report.component';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { ChauffeurPortalComponent } from './chauffeurs/chauffeur-portal/chauffeur-portal.component';
import { PayrollCompareCardComponent } from './chauffeurs/payroll/payroll-compare-card/payroll-compare-card.component';
import { PayrollBreakComponent } from './chauffeurs/payroll/payroll-break/payroll-break.component';
import { BreakStatusDescrPipe } from './chauffeurs/payroll/pipes/break-status-descr.pipe';
import { BreakTypeDescrPipe } from './chauffeurs/payroll/pipes/break-type-descr.pipe';
import { TimesheetsComponent } from './chauffeurs/payroll/timesheets/timesheets.component';
import { BreakEditComponent } from './chauffeurs/payroll/break-edit/break-edit.component';
import { PayrollTimesheetsComponent } from './chauffeurs/payroll/payroll-timesheets/payroll-timesheets.component';


/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    StandbyDashboardComponent,
    DayDetailsComponent,
    DayItemDetailsComponent,
    ReadonlyComponent,
    ReservationsComponent,
    CallBoardDashboardComponent,
    AgentBoardDashboardComponent,
    AuthComponent,
    AlertAnalyzesComponent,
    AlertDetailComponent,
    FeedbackEntryComponent,
    ReportsDashboardComponent,
    TableDataComponent,
    StatsCardComponent,
    ExpWinAccountabilityComponent,
    ExpWinAccountabilityDetailComponent,
    NegToPosPipe,
    NetjetsCrossroadsComponent,
    PageLoaderComponent,
    CardHeaderComponent,
    PageHeaderComponent,
    RateIssueComponent,
    PageDataTableComponent,
    DataTableCardComponent,
    LiveGpsComponent,
    AffPortExceptionComponent,
    AppBuddyComponent,
    TourManagementComponent,
    ViewPayReportComponent,
    WebApplicationsComponent,
    AffRateIssueComponent,
    DataTablePaginationComponent,
    ExcelDocsComponent,
    RatesDashboardComponent,
    DiscountCalculatorComponent,
    TourManagementDetailComponent,
    PayrollComponent,
    ChauffeurPortalComponent,

    VehicleRequestPageComponent,
    WweManifestPageComponent,

    FormInputComponent,
    FormAutoCompleteComponent,
    FormInputComponent,
    FormOkCancelComponent,
    FormCommentComponent,

    EclsButtonComponent,
    CreditCardIdentityCaptureComponent,
    CreditCardIdentityPageComponent,
    UserActivityMonitorComponent,
    TrendReportsComponent,
    TrendDashboardComponent,
    CardChartComponent,
    DataTableComponent,
    FormSelectComponent,
    MinToTimePipe,
    ToastComponent,
    FormProgressComponent,
    ChauffeurEmailsComponent,
    //BreakStatusDescrPipe,

    // customer stuff
    LiveTripsPageComponent,
      SalesmanReportsComponent,
      SalesmanDashboardComponent,
      FrontAnalysisPageComponent,
      VendorPayoutComponent,
      DataTableCardSimpleComponent,
      ChauffeurHrComponent,
      AffiliatePayoutComponent,
      EclsPowerBiReportComponent,
      PayrollCompareCardComponent,
      PayrollBreakComponent,
      BreakStatusDescrPipe,
      BreakTypeDescrPipe,
      TimesheetsComponent,
      BreakEditComponent,
      PayrollTimesheetsComponent
  ],
  imports: [
    MDBBootstrapModulesPro.forRoot(),
    HotkeyModule.forRoot(),
    EosListModule,
    BrowserModule, FormsModule, ReactiveFormsModule, BrowserAnimationsModule,
    AppRoutingModule, HttpClientModule, ToastModule.forRoot(), MdbFileUploadModule,

    // jeff key
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBptB7eRC9SxBx4pR9mcegmgyFDYlyxtfI'
    }),

    PowerBIEmbedModule
  ],
  providers: [
    MDBSpinningPreloader,
    AppCookieService,
    AuthGuard, httpInterceptorProviders
  ],
  schemas: [
    NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
